<template>
  <v-icon :size="size" class="mr-1">
    <img :style="CustomSize" :src="iconPath" class="custom-icon" />
  </v-icon>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    fileType: {
      type: String,
      default: 'png'
    },
    color: {
      type: String,
      default: "white",
    },
    size: {
      type: Number,
      default: 24
    }

  },
  computed: {
    iconPath() {
      // Dynamically generate the path for the icon
      if (this.type == 'labels') {
        return `/images/${this.type}/${this.iconName}.${this.fileType}`;
      } else if (this.type == 'none') {
        return `/images/${this.iconName}.${this.fileType}`;
      }
      return `/images/${this.type}/icon-${this.iconName}.${this.fileType}`;
    },
    CustomSize(){
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,

      }
    }
  }
};
</script>

<style>
.custom-icon {
  /* Set size of the icon */
  width: 24px;
  height: 24px;
}
</style>